import i18n from '../i18n';

// Colors for the non-default urgency tiers of the upcoming-interview countdown label.
// 'normal' urgency intentionally has no override -- callers keep their own default styling.
export const URGENCY_COLORS = {
  urgent: '#F97316',   // within 15 min -- amber/orange accent
  critical: '#EF4444', // within 5 min, or already started -- red accent
};

// Computes the live countdown label + urgency tier for an upcoming interview.
// `status` is currently unused for gating (callers only ever pass rows already
// filtered to non-cancelled/non-completed statuses) but is accepted for clarity
// and in case a wider status set is passed in later.
export function getInterviewCountdown(interviewAtISO, status, now = new Date()) {
  const interviewAt = new Date(interviewAtISO);
  const diffMs = interviewAt.getTime() - now.getTime();
  const diffMin = diffMs / 60000;

  const dateLabel = interviewAt.toLocaleDateString(i18n.language, { month: 'short', day: 'numeric' });
  const timeLabel = interviewAt.toLocaleTimeString(i18n.language, { hour: 'numeric', minute: '2-digit' });

  if (diffMs <= 0) {
    return { text: 'Join now', urgency: 'critical' };
  }
  if (diffMin <= 5) {
    return { text: 'Starting now', urgency: 'critical' };
  }
  if (diffMin <= 15) {
    const rounded = Math.max(5, Math.round(diffMin / 5) * 5);
    return { text: `Interview in ${rounded} min`, urgency: 'urgent' };
  }
  if (diffMin <= 60) {
    const rounded = Math.max(5, Math.round(diffMin / 5) * 5);
    return { text: `Interview in ${rounded} min`, urgency: 'normal' };
  }
  if (diffMin <= 24 * 60) {
    return { text: `Today · ${timeLabel}`, urgency: 'normal' };
  }
  return { text: `${dateLabel} · ${timeLabel}`, urgency: 'normal' };
}
